import { GlobalState, GlyphState } from 'konect-model';
import React, { useEffect, useState } from 'react';

export interface GlyphEditorStateProps {
    state: GlyphState | GlobalState,
    isActive: boolean,
    isEdit: boolean,
    onMouseEnter: Function,
    onMouseLeave: Function,
    isDefaultState?: boolean,
    onCopy?: Function,
    onDelete?: Function,
    onEdit?: Function,
    onDefaultEdit?: Function
    onToggleActive?: Function
}

export default function GlyphEditorState(props: GlyphEditorStateProps) {
    const sta = props.state;
    const [editName, setEditName] = useState(props.isEdit && !sta.name);

    useEffect(() => {
        if (editName) {
            document.getElementById('state-name-input')?.focus();
        }
    }, [editName])

    const toggleNameEdit = () => {
        if (!editName) {
            setEditName(true);
        } else {
            const input = document.getElementById("state-name-input");
            if (input) {
                //@ts-ignore
                sta.name = document.getElementById('state-name-input')?.value;
            }
            setEditName(false);
        }
    }

    return <span
        className={"state-button" + (props.isEdit ? " glyph-state active" : " glyph-state")}
        onMouseEnter={() => props.onMouseEnter(sta)}
        onMouseLeave={() => props.onMouseLeave(sta)}
        onClick={() => { !props.isDefaultState ? props.onEdit && props.onEdit(sta) : props.onDefaultEdit && props.onDefaultEdit() }}>
        {!editName && (sta.name ? sta.name : "Unnamed State")}
        {editName && <input className="name-input" id="state-name-input" defaultValue={sta.name} onKeyDown={(e : any) => {e.keyCode === 13 && toggleNameEdit()}}></input>}
        {!props.isDefaultState &&
            <span style={{maxWidth: props.isEdit ? "10rem" : "0", transition: "max-width 0.1s ease-in-out", display: "inline-flex", overflow: "hidden", marginLeft: "0.5rem", height: "100%",
                marginRight: editName ? "-0.5rem" : "0"}}>
                <span className={"state-visible active"} title="Edit Name"
                    onClick={(e) => { e.stopPropagation(); toggleNameEdit(); }}>
                    <i className={"fas fa-" + (editName ? "check" : "pen")}></i>
                </span>
                {editName && <span className={"state-visible active"} title="Edit Name"
                    onClick={(e) => { e.stopPropagation(); setEditName(false); }}>
                    <i className={"fas fa-times"}></i>
                </span>}
                {!editName && <>
                {props.onCopy && <span className={"state-visible active"} title="Copy State"
                    onClick={(e) => { e.stopPropagation(); props.onCopy && props.onCopy(sta) }}>
                    <i className="fas fa-copy"></i>
                </span>}
                {<span className={"state-visible active"} title="Delete State"
                        onClick={(e) => { e.stopPropagation(); props.onDelete && props.onDelete(sta) }}>
                        <i className="fas fa-trash"></i>
                    </span>}
                </>}
            </span>
        }
        {!props.isDefaultState && !editName && props.onToggleActive &&
            <span className={(props.isActive ? "state-visible active" : "state-visible")}
                title={"Show/Hide State"}
                onClick={(e) => { e.stopPropagation(); props.onToggleActive && props.onToggleActive(sta) }}
                style={{marginRight: "-0.5rem"}}>
                {props.isActive ? <i className="fas fa-eye"></i> : <i className="fas fa-eye-slash"></i>}
            </span>}
    </span>
}